/* src/app/components/confirm-email-reset-password/confirm-email-reset-password.component.scss */
.confirmform {
  width: 100%;
}
/*# sourceMappingURL=confirm-email-reset-password.component.css.map */
